import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';

import { Provider } from 'react-redux';
import App from './App';

// mc
import store from './mc/store';

ReactDOM.render(
    <Provider store={store}>
        {/*<Router basename={pathname}>*/}
        {/*    <Route strict path="/" component={App} />*/}
        {/*</Router>*/}
        <App/>
    </Provider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();